import React, { useState, useEffect } from 'react';
import { injectIntl } from 'react-intl';
import FilesList from '../FilesUploader/FilesList';
import { useSelector } from 'react-redux';
import Loader from '../ui/Loader';
import { Slide, ToastContainer, toast } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { TOAST_TYPE } from '../FilesUploader/constants';
import {
  getMetaTagsWithUMOID,
  getMetaValuesWithUMOID,
} from './httpServices.jsx';
import appConfig from '../../appConfig.js';
import Error from '../Icons/Error.jsx';
import CloseIcon from '../Icons/CloseIcon.jsx';
import piction from '../../utils/piction.js';
import PictionJS from 'piction-js';
import { getFileSize } from './helpers.jsx';

const BulkMetaEdit = ({ homeScreenRefresh, intl }) => {
  const [images, setImages] = useState([]);
  const [isDropAreaVisible, setIsDropAreaVisible] = useState(false);
  const [metaTags, setMetaTags] = useState([]);
  const [searchResults, setSearchResults] = useState([]);
  const [isStartUpLoading, setIsStartUpLoading] = useState(false);
  const hstPath = appConfig.hostURL;
  const csrf = sessionStorage.getItem('token');
  const [isUploading, setIsUploading] = useState(false);
  const [completedApiCount, setCompletedApiCount] = useState([]);
  const [isError, setIsError] = useState(false);
  const [isFilesUploaded, setIsFilesUploaded] = useState(false);
  const [metaValues, setMetaValues] = useState([]);
  const [isJobProcessing, setIsJobProcessing] = useState(false);
  const [isAllJobsFinished, setIsAllJobsFinished] = useState([]);

  const selectedUMOIDs = useSelector((state) => {
    return state.umoGallery.get('selectedUMOIDs');
  });
  const isSelectAll = useSelector((state) => {
    return state.umoGallery.get('isSelectAll');
  });
  const umoList = useSelector((state) => {
    return state.umoGallery.get('umoList');
  });
  const allUmoIds = umoList?.map((umo) => umo.toJS()?.id[0]);

  const isSurlCookie = useSelector((state) => {
    return state.session.get('surlCookie');
  });
  const surlFromSession = useSelector((state) => {
    return state.session.get('surl');
  });

  const surl = (isSurlCookie && '') || surlFromSession;

  const fetchTags = async () => {
    try {
      setIsStartUpLoading(true);

      if (isSelectAll && allUmoIds.size == 0) {
        setIsStartUpLoading(false);
        setIsError(true);
        return;
      } else if (!isSelectAll && selectedUMOIDs.size == 0) {
        setIsStartUpLoading(false);
        setIsError(true);
        return;
      }

      const res = await getMetaTagsWithUMOID(
        hstPath,
        isSelectAll ? allUmoIds.toJS()[0] : selectedUMOIDs.toJS()[0],
        surl,
        csrf
      );
      if (res) {
        setMetaTags(Array.isArray(res) ? res : []);
      } else {
        setIsError(true);
      }
    } catch (e) {
      setIsStartUpLoading(false);
      setIsError(true);
    }
  };
  const fetchValues = async () => {
    try {
      if (isSelectAll && allUmoIds.size == 0) {
        setIsStartUpLoading(false);
        setIsError(true);
        return;
      } else if (!isSelectAll && selectedUMOIDs.size == 0) {
        setIsStartUpLoading(false);
        setIsError(true);
        return;
      }
      const res = await getMetaValuesWithUMOID(
        hstPath,
        isSelectAll
          ? allUmoIds.toJS()?.join(',')
          : selectedUMOIDs.toJS()?.join(','),
        surl,
        csrf
      );
      if (!res || !Array.isArray(res) || res.length === 0) {
        setIsError(true);
      } else {
        setSearchResults(res);
        setIsStartUpLoading(false);
      }
    } catch (e) {
      setIsError(true);
    }
  };

  useEffect(() => {
    fetchTags();
    fetchValues();
  }, []);

  useEffect(() => {
    if (searchResults) {
      let images = [];
      searchResults.map((umo) => {
        let tempUMO = umoList.find((u) => {
          return u.toJS()?.id[0] === umo.id;
        });
        tempUMO = new PictionJS.UMO(tempUMO.toJS(), {
          hostURL: piction.hostURL,
        });

        images.push({
          umoId: umo.id,
          data_url: umo.i[0].thumbnail,
          file: {
            name: umo.n,
            size: getFileSize(tempUMO),
          },
        });
      });
      setImages(images);
    }
  }, [searchResults]);

  const showToast = (message, toast_type) => {
    const toastParam = {
      position: 'bottom-right',
      autoClose: 5000,
      hideProgressBar: false,
      closeOnClick: true,
      pauseOnHover: true,
      draggable: true,
      progress: undefined,
      theme: 'light',
      transition: Slide,
    };
    switch (toast_type) {
      case TOAST_TYPE.ERROR:
        toast.error(message, toastParam);
        break;
      case TOAST_TYPE.SUCCESS:
        toast.success(message, toastParam);
      default:
        break;
    }
  };

  const onImageRemove = (index) => {
    setImages((prevImages) => {
      let temp = [...prevImages];
      temp.splice(index, 1);
      return temp;
    });
  };
  return (
    <div className="photo-uploader__container photo-uploader__container-me">
      <ToastContainer
        position="bottom-right"
        autoClose={10000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
        theme="light"
        transition={Slide}
      />
      <div className="photo-uploader__header-container">
        <h2 className="photo-uploader__header-container__header-text font-lg-medium">
          {intl.formatMessage({ id: 'umoGridItem.menuEditMetaData' })}
        </h2>
      </div>

      <div className="photo-uploader__card">
        <div className="photo-uploader__card-wrapper">
          {(isStartUpLoading || isUploading) && (
            <div className="photo-uploader__loader-container">
              <Loader isLarge={true} className="photo-uploader__loader" />'
              <h5 className="font-md-regular">
                {isStartUpLoading && 'Loading, please wait.'}
                {isUploading &&
                  `Updating ${completedApiCount.reduce(
                    (total, currentValue) => total + (currentValue ? 1 : 0),
                    0
                  )}/${images.length}, please wait`}
              </h5>
            </div>
          )}
          {isError && (
            <div className="photo-uploader__loader-container">
              <div
                className="photo-uploader__loader-error-icon"
                onClick={homeScreenRefresh}
              >
                <CloseIcon height={'30px'} width={'30px'} />
              </div>
              <Error height={'40px'} width={'40px'} />
              <h5 className="font-md-regular ">
                {intl.formatMessage({ id: 'general.error' })}
                <br />
                {intl.formatMessage({ id: 'general.tryAgain' })}
              </h5>
            </div>
          )}
          <div className="photo-uploader__card-inner-wrap">
            {/* Images List */}
            <FilesList
              // meta-edit
              showMetaEditVersion={true}
              searchResults={searchResults}
              //file-uploader
              imageList={images}
              onImageRemove={onImageRemove}
              onImageUpdate={() => {}}
              setIsDropAreaVisible={setIsDropAreaVisible}
              onImageRemoveAll={() => {}}
              metaTags={metaTags}
              maxFileSize={null}
              hstPath={hstPath}
              categoryIdToUpload={null}
              surl={surl}
              csrf={csrf}
              isUploading={isUploading}
              setIsUploading={setIsUploading}
              completedApiCount={completedApiCount}
              setCompletedApiCount={setCompletedApiCount}
              setIsError={setIsError}
              showToast={showToast}
              setIsFilesUploaded={setIsFilesUploaded}
              metaValues={metaValues}
              setMetaValues={setMetaValues}
              setIsJobProcessing={setIsJobProcessing}
              isJobProcessing={isJobProcessing}
              isAllJobsFinished={isAllJobsFinished}
              setIsAllJobsFinished={setIsAllJobsFinished}
              homeScreenRefresh={homeScreenRefresh}
              setFilesLoadingStatus={() => {}}
              setIsUploadingIndicatorShown={() => {}}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default injectIntl(BulkMetaEdit);
